interface CheckIconProps {
  color: string
}

const CheckIcon = ({ color }: CheckIconProps) => (
  <svg width="10" height="10" viewBox="0 0 12 12" fill="none">
    <path
      d="M10 3L4.5 8.5L2 6"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default CheckIcon
